import { render, staticRenderFns } from "./RedisAdmin.vue?vue&type=template&id=1fe12277"
import script from "./RedisAdmin.vue?vue&type=script&lang=js"
export * from "./RedisAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports